import React from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { DataTable } from 'src/components/DataTable';
import { ROLES_LIST } from 'src/components/enterprise/features/Employee/utils/employeeRoles.utils';
import { EmployeeListFilters } from 'src/components/enterprise/features/Employee/utils/employee.utils';

export function EmployeeRoleFilter(): JSX.Element | null {
  const {
    enterpriseData: { isInternalAdminUser },
  } = useAuth();

  if (!isInternalAdminUser) {
    return null;
  }

  return (
    <DataTable.SingleSelectFilter<EmployeeListFilters>
      filterKey="diner_role"
      placeholder="Role"
      clearLabel="All Roles"
      options={ROLES_LIST}
    />
  );
}
